/** 元转分（四舍五入） */
export const yuanToFen = (yuan) => {
  if (yuan == null || Number.isNaN(Number(yuan))) return null
  return Math.round(Number(yuan) * 100)
}

export const buildRescheduleFeeSnapshot = (feeData, passengers = []) => {
  if (!feeData?.available || !passengers?.length) return null
  const feePassengers = feeData.passengers || []
  return {
    passengers: passengers.map((passenger) => {
      const fee = feePassengers.find(
        (item) =>
          String(item.passengerId) === String(passenger.id) ||
          item.realName === passenger.realName
      )
      const oldTicketPriceFen =
        passenger.originalAmount != null
          ? passenger.originalAmount
          : yuanToFen(fee?.oldTicketPriceYuan)
      const ticketPriceFen =
        passenger.amount != null ? passenger.amount : yuanToFen(fee?.newTicketPriceYuan)
      const rescheduleFeeFen = yuanToFen(fee?.rescheduleFeeYuan)
      const rescheduleServiceFeeFen = yuanToFen(fee?.serviceFeeYuan)
      const payAmountYuan = fee?.payAmountYuan != null ? Number(fee.payAmountYuan) : null
      const priceDiffYuan = fee?.priceDiffYuan != null ? Number(fee.priceDiffYuan) : 0
      let reschedulePayAmountFen = yuanToFen(payAmountYuan)
      let refundAmountFen = null
      if (payAmountYuan != null && payAmountYuan < 0) {
        refundAmountFen = yuanToFen(Math.abs(payAmountYuan))
        reschedulePayAmountFen = 0
      } else if (priceDiffYuan < 0 && payAmountYuan == null) {
        refundAmountFen = yuanToFen(Math.abs(priceDiffYuan))
      }
      return {
        passengerId: passenger.id,
        orderItemId: passenger.orderItemId || null,
        oldTicketPriceFen,
        ticketPriceFen,
        rescheduleFeeFen,
        rescheduleServiceFeeFen,
        reschedulePayAmountFen,
        refundAmountFen
      }
    })
  }
}

export const buildRefundFeeSnapshot = (
  feeData,
  selectedPassengerIds,
  orderPassengers = []
) => {
  if (!feeData?.available || !selectedPassengerIds?.length) return null
  const selectedIdSet = new Set(selectedPassengerIds.map(String))
  const selectedPassengers = orderPassengers.filter((p) =>
    selectedIdSet.has(String(p.id))
  )
  const feePassengers = feeData.passengers || []
  return {
    passengers: selectedPassengers.map((passenger) => {
      const fee = feePassengers.find(
        (item) =>
          String(item.passengerId) === String(passenger.id) ||
          item.realName === passenger.realName
      )
      const refundServiceFeeYuan =
        fee?.refundServiceFeeYuan != null ? Number(fee.refundServiceFeeYuan) : 0
      const railwayRefundFeeYuan =
        fee?.refundFeeYuan != null ? Number(fee.refundFeeYuan) : 0
      const refundAmountYuan =
        fee?.refundAmountYuan != null ? Number(fee.refundAmountYuan) : 0
      return {
        orderItemId: passenger.id,
        idCard: passenger.idCard,
        ticketPriceFen: passenger.amount ?? yuanToFen(fee?.ticketPriceYuan),
        refundFeeFen: yuanToFen(railwayRefundFeeYuan),
        refundServiceFeeFen: yuanToFen(refundServiceFeeYuan),
        refundAmountFen: yuanToFen(refundAmountYuan)
      }
    })
  }
}
